import getDynamicMenuPosition from '../../utils/getDynamicMenuPosition';
import React, { useEffect, useState } from 'react';
import { useEditorView } from '@remirror/react';
import ShortcutMenu from '../ShortcutMenu';
import { Dropdown } from 'antd';

const MENU_WIDTH = 256;
const MENU_ITEM_HEIGHT = 36;
const GROUP_LABEL_HEIGHT = 28;
const MENU_HEIGHT = 6 * MENU_ITEM_HEIGHT;

function MentionShortcut({ open, items, selectedItem, onClickHandler, range }) {
  const [placementMemory, setPlacementMemory] = useState(null);
  const editorView = useEditorView();

  useEffect(() => {
    setPlacementMemory(null);
  }, [open]);

  if (!open) return null;

  const itemsLength = Object.values(items).flat().length;
  const menuMaxHeight = itemsLength * MENU_ITEM_HEIGHT + Object.keys(items)?.length * GROUP_LABEL_HEIGHT + 16;
  const pos = getDynamicMenuPosition({
    coords: editorView.coordsAtPos(range?.from),
    maxWidth: MENU_WIDTH,
    maxHeight: itemsLength === 0 ? MENU_HEIGHT : Math.min(MENU_HEIGHT, menuMaxHeight),
    prevPlacement: placementMemory,
  });
  if (pos.placement !== placementMemory) {
    setPlacementMemory(pos.placement);
  }

  return (
    <>
      <Dropdown
        autoFocus
        destroyPopupOnHide
        overlayClassName={`cms-shortcut mention-shortcut-menu${Object.keys(items).length === 0 ? ' collapse' : ''}`}
        menu={{ items: items, selectable: true, selectedKeys: [selectedItem] }}
        dropdownRender={({ props }) => (
          <ShortcutMenu {...props} selectedOption={selectedItem} onClickHandler={onClickHandler} items={items} />
        )}
        open={open}
        trigger={[]}
        placement="bottomLeft"
        overlayStyle={{
          '--shortcut-menu-width': MENU_WIDTH,
          '--shortcut-menu-height': MENU_HEIGHT,
          borderRadius: '0px',
          top: pos.placement === 'top' ? pos?.top - 10 : pos?.top + 5,
          left: pos?.left ?? 100,
        }}
      >
        <span style={{ position: 'absolute', left: '0px', top: '0px', zIndex: 1, pointerEvents: 'none' }}>&nbsp;</span>
      </Dropdown>
    </>
  );
}

export default MentionShortcut;
